import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PaymentService } from '../../../pay/services/payment.service';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
standalone: false,
  selector: 'app-topup-disabled-block-payment-dialog',
  templateUrl: './topup-disabled-block-payment-dialog.component.html',
  styleUrls: ['./topup-disabled-block-payment-dialog.component.scss'],
})
export class TopUpDisabledBlockPaymentDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      redirectUrl: string;
      paymentId: string;
      ids: Array<string>;
      cancel: boolean;
    },
    private dialogRef: MatDialogRef<TopUpDisabledBlockPaymentDialogComponent>,
    private paymentService: PaymentService,
    private router: Router,
  ) {}

  removeFromCart() {
    if (this.data?.cancel) {
      this.paymentService
        .cancelPayment(this.data.paymentId)
        .pipe(
          tap(() => this.paymentService.refreshBasePayment()),
          tap(() => this.router.navigate(['/liabilities/all'])),
        )
        .subscribe();
    } else {
      this.paymentService
        .recreatePayment(this.data.paymentId, { removedLiabilityIds: [...this.data.ids] })
        .pipe(
          tap((newPaymentId) => {
            this.router.navigate([this.data.redirectUrl + newPaymentId]);
          }),
          tap(() => this.paymentService.refreshBasePayment()),
        )
        .subscribe();
    }

    this.dialogRef.close({ removeIds: true });
  }
}
